import React, { useCallback, useContext, useLayoutEffect, useState } from "react";
import { AXIOS_GET } from "../../server/api/crud";
import { getUser, signOutUser } from "../../Localstorage/localstorage";
import { useNavigate } from "react-router-dom";
import DashboardAdmin from "./DashboardAdmin";
import DashboardClient from "./DashboardClient";
import { AuthContext } from "../../context/AuthContext";



const Dashboard = () => {
  const selectedUser = getUser();
  const [user, setUser] = useState(null)
  const navigate = useNavigate();
  const { logout } = useContext(AuthContext);

  const clearSessionAndGoSignIn = useCallback(() => {
    signOutUser();
    logout();
    navigate("/signin", { replace: true });
  }, [logout, navigate]);

  const fetchData = useCallback(async (p_id) => {
    try {
      const response = await AXIOS_GET(`users/${p_id}`);
      const rows = response?.data?.data;
      if (!Array.isArray(rows) || rows.length === 0) {
        throw new Error("User profile not found");
      }
      setUser(rows[0]);
    } catch (error) {
      console.error("Error fetching data:", error);
      clearSessionAndGoSignIn();
    }
  }, [clearSessionAndGoSignIn]);

  useLayoutEffect(() => {
    if (!selectedUser?.id) {
      clearSessionAndGoSignIn();
      return;
    }
    fetchData(selectedUser.id);
  }, [selectedUser?.id, fetchData, clearSessionAndGoSignIn]);

 if (user?.role_id == 1) return (
   <DashboardAdmin/>
  );

  if (user?.role_id == 2) return (
   <DashboardClient/>
  );

  return (
    <div className="w-full h-96 flex items-center justify-center">
      Aan het laden...
    </div>
  );
};

export default Dashboard;
